module.exports = __webpack_public_path__ + "static/media/ImageWithFallback.9d5c0d83.png";